import { db } from '../client/index';
import { collection, getDocs, doc, addDoc, deleteDoc, query, where } from 'firebase/firestore/lite';
import { getPolicy } from './policies.service';

const rolesPoliciesCollection = collection(db, 'roles-policies');

export const getPoliciesByRole = async (roleId) => {
  try {
    const querySnapshot = query(rolesPoliciesCollection, where('role', '==', roleId));
    const queryItems = (await getDocs(querySnapshot)).docs;
    const policiesMap = queryItems.map(rolePolicy => rolePolicy.data().policy);
    const policiesPromises = policiesMap.map(policy => getPolicy(policy));
    const policiesItems = await Promise.all(policiesPromises);
    return policiesItems;
  } catch (err) {
    return err;
  }
}

export const addPolicyToRole = async (roleId, policyId) => {
  try {
    const rolePolicy = {
      role: roleId,
      policy: policyId
    }
    const { id } = await addDoc(rolesPoliciesCollection, rolePolicy);
    const rolePolicyAdded = { id, ...rolePolicy };
    return rolePolicyAdded;
  } catch (err) {
    return err;
  }
}

export const deletePolicyFromRole = async (id) => {
  try {
    const rolePolicyRef = doc(db, 'roles-policies', id);
    await deleteDoc(rolePolicyRef);
    return id;
  } catch (err) {
    return err;
  }
}